import { create } from 'zustand';

interface Assets {
  logo: string;
  landingImage: string;
}

interface AssetStore {
  assets: Assets;
  loadAssets: () => Promise<void>;
}

const useAssetStore = create<AssetStore>((set) => ({
  assets: {
    logo: '/assets/MSA-Logo.jpg',
    landingImage: '/assets/headerLanding.png',
  },
  loadAssets: async () => {
    try {
      const timestamp = Date.now();
      const response = await fetch(`/assets.json?v=${timestamp}`);
      const data: Assets = await response.json();
      set({ assets: data });
    } catch (error) {
      console.error('Failed to load assets:', error);
    }
  },
}));

export default useAssetStore;
